
import React, { useState } from 'react';
import Header from '@/components/Header';
import ConsumerSummaryCard from '@/components/energy/consumers/ConsumerSummaryCard';
import TopConsumersCard from '@/components/energy/consumers/TopConsumersCard';
import DefaulterConsumersTable from '@/components/energy/consumers/DefaulterConsumersTable';
import ConsumptionTrendsCard from '@/components/energy/consumers/ConsumptionTrendsCard';
import AllConsumersDialog from '@/components/energy/consumers/AllConsumersDialog';
import { topConsumers, defaulterConsumers, allEnergyConsumers } from '@/data/energy-consumers-data';

const Consumers = () => {
  const [showAllConsumers, setShowAllConsumers] = useState(false);
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <main className="pt-20 md:pt-24 pb-6 md:pb-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
          <ConsumerSummaryCard onViewAllClick={() => setShowAllConsumers(true)} />
          <TopConsumersCard consumers={topConsumers} />
        </div>
        
        <DefaulterConsumersTable defaulters={defaulterConsumers} />
        
        <div className="mt-6 md:mt-8">
          <ConsumptionTrendsCard />
        </div>
      </main>

      <AllConsumersDialog 
        open={showAllConsumers} 
        onOpenChange={setShowAllConsumers} 
        consumers={allEnergyConsumers} 
      />
    </div>
  );
};

export default Consumers;
